/**
 * @module task_templates (action-planning "library actions")
 */
import { createReducer } from '@reduxjs/toolkit';
import { taskTemplateActions } from '~/behaviors/actions/task_template.actions';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeTemplates = (state, action) => {
  const templates = action?.payload?.entities?.taskTemplates || [];

  Object.values(templates).forEach((template) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[template.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[template.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...template,
    };
  });
};

const mergeTemplate = (state, action) => {
  const template = action?.payload?.template || {};

  state[template.id] = {
    ...state[template.id],
    ...template,
  };
};

const removeTemplate = (state, action) => {
  const id = action?.payload?.id;

  if (id) {
    const { [id]: _deletedTask, ...remainingTasks } = state;

    return remainingTasks;
  }
};

const taskTemplates = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(taskTemplateActions.fetchTaskTemplate.fulfilled, mergeTemplate);
  builder.addCase(taskTemplateActions.fetchTaskTemplateList.fulfilled, mergeTemplates);
  builder.addCase(taskTemplateActions.createTaskTemplate.fulfilled, mergeTemplates);
  builder.addCase(taskTemplateActions.modifyTaskTemplate.fulfilled, mergeTemplates);
  builder.addCase(taskTemplateActions.removeTaskTemplate.fulfilled, removeTemplate);
  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, mergeTemplates);
});

export default taskTemplates;
